import { render, staticRenderFns } from "./Notebooks.vue?vue&type=template&id=c636ab76&scoped=true&"
import script from "./Notebooks.vue?vue&type=script&lang=js&"
export * from "./Notebooks.vue?vue&type=script&lang=js&"
import style0 from "./Notebooks.vue?vue&type=style&index=0&id=c636ab76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c636ab76",
  null
  
)

export default component.exports